import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as externalCampaignListsActions from '../../../redux/actions/ExternalCampaignListsActions';
import * as suggestionActions from '../../../redux/actions/SuggestionsActions';

import ExternalParticipantsInfiniteList from './ExternalParticipantsInfiniteList';
import SelectExternalParticipantModal from './SelectExternalParticipantModal';
import ExternalParticipantModal from './ExternalParticipantModal';
import ExportButton from '../../commonComponents/shared/ExportButton';
import NavigationComponent from '../../commonComponents/util/NavigationComponent';
import ConfirmationModal from '../../commonComponents/shared/ConfirmationModal';
import WarningModal from '../../commonComponents/shared/WarningModal';
import LoadingSpinner from '../../commonComponents/util/LoadingSpinner';

import { Departments, RecipientTypes } from '../../../lib/systemVariables';
import { locationIsIsraeli, formatDate } from '../../../lib/utils';
import { debounce } from 'throttle-debounce';
import { getQueryParams, setQueryParams } from '../../../lib/urlUtils';

const listTypes = {
  New: 'new',
  Received: 'received',
  Rejected: 'rejected'
};

class ExternalCampaignListPage extends NavigationComponent {
  state = {
    currentParticipant: {},
    listType: null,
    deselected: [],
    searchKeyword: '',
    selected: [],
    showModals: {
      removeRestoreConfirmationModal: false,
      externalParticipantModal: false,
      selectExternalParticipantModal: false,
      submitListConfirmationModal: false
    },
    submitted: false
  };

  componentWillMount() {
    this.getListDetails();
  }

  getListDetails = async () => {
    await this.props.actions.getExternalCampaignListDetails(this.props.campaignListId);

    const {
      listDetails: { data: campaignList }
    } = this.props;

    if (campaignList.batch) {

      let listType = getQueryParams().list || listTypes.New;

      if (
        listType === listTypes.Received &&
        !campaignList.receivedParticipantsCount
      ) {
        listType = campaignList.newParticipantsCount ? listTypes.New : listTypes.Rejected;
      } else if (
        listType === listTypes.New &&
        !campaignList.newParticipantsCount
      ) {
        listType = campaignList.receivedParticipantsCount ? listTypes.Received : listTypes.Rejected;
      } else if (
        listType === listTypes.Rejected &&
        !campaignList.rejectedParticipantsCount
      ) {
        listType = campaignList.newParticipantsCount ? listTypes.New : listTypes.Received;
      }

      this.toggleListType(listType, false);


      //get existing recipients to blacklist from suggestions
      await this.props.actions.getExternalCampaignListRecipients(this.props.campaignListId);
    }
  };

  getParticipants = (reset, page, sort) => {
    this.props.actions.getExternalCampaignListParticipants(
      this.props.campaignListId,
      this.state.listType,
      this.state.searchKeyword,
      reset,
      page,
      sort
    );
  };

  toggleListType = (listType, getParticipants = true) => {
    setQueryParams({ list: listType });
    this.setState({ listType }, () => {
      if (getParticipants) this.getParticipants(true);
    });
  };

  updateSearch = event => {
    this.setState({ searchKeyword: event.target.value }, this.debounceSearchList);
  };

  debounceSearchList = debounce(500, () => {
    this.getParticipants(true, 1, this.props.participantsList.sort);
  });

  addParticipant = async participant => {
    await this.props.actions.addExternalCampaignListParticipant(this.props.campaignListId, participant);

    if (participant.recipientId) { //reload recipients blacklist if chose suggestion...
      this.props.actions.getExternalCampaignListRecipients(this.props.campaignListId);
    }

    if (this.state.listType !== listTypes.New) this.toggleListType(listTypes.New);
  };

  updateParticipant = async participant => {
    await this.props.actions.updateExternalCampaignListParticipant(this.props.campaignListId, participant);
  };

  removeParticipant = async () => {
    await this.props.actions.removeExternalCampaignListParticipant(
      this.props.campaignListId,
      this.state.currentParticipant.externalListMemberId
    );
  };

  restoreParticipant = async () => {
    await this.props.actions.restoreExternalCampaignListParticipant(
      this.props.campaignListId,
      this.state.currentParticipant.externalListMemberId
    );
  };

  selectParticipant = (participantId, select) => {
    const { deselected, selected } = this.state;

    const restoreDefault = (select ? deselected.indexOf(participantId) : selected.indexOf(participantId)) >= 0;

    this.setState(
      {
        deselected:
          !select && !restoreDefault ? [...deselected, participantId] : deselected.filter(id => id !== participantId),
        selected: select && !restoreDefault ? [...selected, participantId] : selected.filter(id => id !== participantId)
      },
      this.debounceSaveSelectedParticipants
    );
  };

  debounceSaveSelectedParticipants = debounce(2000, () => {
    this.saveSelectedParticipants();
  });

  selectAllParticipantsToggle = async toggleAll => {
    this.saveSelectedParticipants(toggleAll);
  };

  saveSelectedParticipants = async toggleAll => {
    const { deselected, selected } = this.state;
    const { listSelection } = this.props;

    if (selected.length || deselected.length || toggleAll) {
      await this.props.actions.toggleExternalCampaignListParticipantsReceiving(
        this.props.campaignListId,
        selected,
        deselected,
        toggleAll,
        this.state.listType,
        this.state.searchKeyword
      );
      if (listSelection.success) {
        this.setState({
          deselected: this.state.deselected.filter(id => deselected.indexOf(id) < 0),
          selected: this.state.selected.filter(id => selected.indexOf(id) < 0)
        });
      }
    }
  };

  exportList = async () => {
    await this.props.actions.exportExternalCampaignList(this.props.campaignListId);

    return this.props.listExport;
  };

  submitList = async () => {
    await this.props.actions.submitExternalCampaignList(this.props.campaignListId);

    if (this.props.listSubmission.success) {
      this.setState({ submitted: true });
    }
  };

  render() {
    const {
      listDetails: { data: campaignList },
      listRecipients,
      listDetails,
      listExport,
      listUpdate,
      listSelection,
      listSubmission,
      settings: { usPersonTitles, israelPersonTitles, locationGroups, orgEmploymentTypes, previousEmploymentTypes }
    } = this.props;
    const { currentParticipant, deselected, listType, searchKeyword, selected, showModals, submitted } = this.state;
    const isBatched = campaignList.batch;
    const isIsraeli = locationIsIsraeli(locationGroups, campaignList.locationId);
    const unsavedSelection = selected.length > 0 || deselected.length > 0;
    const style = `staff-list-table mt-16 ${isIsraeli ? 'israeli-table' : campaignList.isOrgList ? 'org-table' : ''} ${(isBatched && listType === listTypes.Received) ? "received-table" : ""} ${(isBatched) ? "batched-list-table" : ""}`

    return (
      <div className="secondary-page external-page">
        {listDetails.loading ? (
          <div className="full-page-empty-state">
            <p className="accent-text2">Retrieving campaign list information...</p>
          </div>
        ) : !listDetails.success ? (
          <div className="full-page-empty-state">
            <img src="/images/logo.png" alt="logo" />
            <p>Something went wrong and we were unable to retrieve your campaign list. Please try again.</p>
          </div>
        ) : (
              !!campaignList.campaignListId && (
                <div>
                  <div className="external-page-header">
                    <div className="container flex">
                      <h4 className="page-header">
                        {campaignList.name} Campaign List
                        {campaignList.lastSubmitted && (
                          <p className="medium-text accent-text mt-8">Last Submitted: {formatDate(campaignList.lastSubmitted)}</p>
                        )}
                      </h4>


                      {!campaignList.awaitingVerification && !submitted && (!isBatched || listType) && (
                        <div style={{ display: 'contents' }}>
                          <div className="flex flex-justify" style={{ flex: '1', alignItems: 'flex-start' }}>
                            <button
                              className="btn btn-primary flex flex-center ml-16"
                              disabled={listSubmission.loading}
                              onClick={() => this.toggleModal(isBatched ? 'selectExternalParticipantModal' : 'externalParticipantModal')}
                            >
                              <i className="material-icons mr-8" style={{ fontSize: '18px' }}>
                                add_circle_outline
                          </i>
                              Add New Participant
                        </button>
                            <div className="flex flex-center">
                              {isBatched &&
                                (listSelection.loading ? (
                                  <div className="flex flex-center mr-16 accent-text2 small-text">
                                    <LoadingSpinner height="12" />{' '}
                                    <span style={{ marginLeft: '8px' }}>Saving selection...</span>
                                  </div>
                                ) : !listSelection.success ? (
                                  <p className="small-text error-text mr-16">
                                    Attempt to save selection failed.{' '}
                                    <span className="error-text small-text bold-text pointer" onClick={this.saveSelectedParticipants}>
                                      Try again.
                                    </span>
                                  </p>
                                ) : unsavedSelection ? (
                                  <p className="mr-16 accent-text2 small-text">
                                    Unsaved selection.{' '}
                                    <span className="accent-text2 small-text bold-text pointer" onClick={this.saveSelectedParticipants}>
                                      Save now.
                                    </span>
                                  </p>
                                ) : (
                                        campaignList.receivingParticipantsCount > 0 && (
                                          <span className="accent-text2 medium-text mr-8">
                                            {campaignList.receivingParticipantsCount} individual
                                  {campaignList.receivingParticipantsCount === 1 ? '' : 's'} selected for submission
                                </span>
                                        )
                                      ))}

                              <button
                                className="btn btn-primary-outline mr-8 flex flex-center"
                                disabled={
                                  unsavedSelection || listSelection.loading || listSubmission.loading
                                }
                                onClick={() => this.toggleModal('submitListConfirmationModal')}
                              >
                                <i className="material-icons mr-8" style={{ fontSize: '18px' }}>
                                  check_circle_outline
                            </i>
                                Submit
                          </button>

                              <ExportButton
                                disabled={unsavedSelection || listSelection.loading || listSubmission.loading}
                                error={!listExport.loading && !listExport.success}
                                exporting={listExport.loading}
                                exportHeaders={[
                                  { label: 'Name', value: 'displayName', default: '' },
                                  { label: 'Phone', value: 'phoneNumber', default: '' },
                                  { label: 'Address', value: 'addressDisplay', default: '' },
                                  ...(isIsraeli
                                    ? [
                                      { label: 'Teudat Zehut', value: 'teudatZahut', default: '' },
                                      { label: 'Bank Number', value: 'bankRoutingNumber', default: '' },
                                      { label: 'Branch Number', value: 'bankBranchNumber', default: '' },
                                      { label: 'Account Number', value: 'bankAccountNumber', default: '' },
                                      { label: 'Account Holder', value: 'bankAccountHolder', default: '' }
                                    ]
                                    : []),
                                    ...(!isIsraeli && campaignList.isOrgList)
                                    ? [
                                        { label: 'Position', value: 'orgEmployment', sortable: false },
                                    ] : [],
                                  ...(isBatched
                                    ? [
                                      {
                                        label: 'Is Receiving',
                                        value: vals => (vals.isReceiving ? '*' : ''),
                                        default: ''
                                      },
                                      {
                                        label: 'Number of Times Received',
                                        value: vals => vals.numberOfTimesReceived || '',
                                        default: ''
                                      }
                                    ]
                                    : [])
                                ]}
                                fileName={campaignList.name ? campaignList.name.split(' ').join('-') : 'Campaign-list'}
                                getDataForExport={this.exportList}
                              />
                            </div>
                          </div>
                          {isBatched &&
                            <div className="full-width">
                              <p className="small-text" style={{ color: 'rgba(45,53,92,0.7)', lineHeight: '1.5' }}>
                                Please check off individuals for submission. Unchecked individuals will remain on the list as
                                stand-by. Please delete individuals that need to be removed entirely and edit any information
                                about individuals that need updating. {
                                  (campaignList.receivedParticipantsCount > 0) &&
                                  'The “Received” tab shows all previously submitted individuals who can be checked off for an additional submission.'
                                }
                                {
                                  (campaignList.rejectedParticipantsCount > 0) &&
                                  'The “Rejected” tab shows all previously submitted individuals who were rejected.'
                                }
                              </p>
                            </div>
                          }
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="relative">
                    <div className="thead-background" />
                  </div>

                  {(campaignList.awaitingVerification || submitted)
                    ? (
                      <div className="container relative mt-16">
                        Your campaign list has been submitted and is awaiting verification by an SFTF staff member.
                      </div>
                    ) : (
                      <div className="container secondary-page-content">
                        <div className="flex flex-center flex-justify" style={{ height: '56px' }}>
                          {(isBatched && (campaignList.receivedParticipantsCount > 0 || 
                                          campaignList.rejectedParticipantsCount > 0)) && (
                            <div className="count">
                              {Object.keys(listTypes).map(typeKey => {
                                const type = listTypes[typeKey];
                                const typeCount = campaignList[`${type}ParticipantsCount`];
                                const active = listType === type;
                                const disabled = !typeCount || unsavedSelection || listSelection.loading;

                                return (
                                  typeCount > 0 ?
                                  (<span
                                    className={active ? 'active' : disabled ? 'disabled' : 'pointer'}
                                    key={type}
                                    onClick={() => {
                                      if (listType !== type && !disabled) this.toggleListType(type);
                                    }}
                                  >
                                    {type.toUpperCase()} ({typeCount || 0})
                                  </span>) : ""
                                );
                              })}
                            </div>
                          )}
                          <div className="search-input">
                            <i className="material-icons">search</i>
                            <input
                              type="text"
                              onChange={this.updateSearch}
                              placeholder="Search participants"
                              value={searchKeyword}
                              style={{ maxWidth: '280px', marginBottom: '0' }}
                            />
                          </div>
                        </div>

                        <div className={style}>
                          {
                            (!isBatched || listType) &&
                            <ExternalParticipantsInfiniteList
                              campaignListName={campaignList.name}
                              isBatched={isBatched}
                              isIsraeli={isIsraeli}
                              isOrgList={campaignList.isOrgList}
                              listType={listType}
                              listTypes={listTypes}
                              savingSelection={listSelection.loading}
                              {...this.props.participantsList}
                              getParticipants={(page, sort, reset = false) => this.getParticipants(reset, page, sort)}
                              deselected={deselected}
                              selected={selected}
                              toggleRemoveRestoreParticipant={currentParticipant => {
                                this.setState({ currentParticipant }, () => this.toggleModal('removeRestoreConfirmationModal'));
                              }}
                              updateParticipant={currentParticipant => {
                                this.setState({ currentParticipant }, () => this.toggleModal('externalParticipantModal'));
                              }}
                              selectParticipant={this.selectParticipant}
                              selectAllParticipantsToggle={this.selectAllParticipantsToggle}
                            />
                          }
                        </div>

                        <ConfirmationModal
                          show={showModals.removeRestoreConfirmationModal}
                          message={
                            !currentParticipant.externalListMemberId
                              ? ''
                              : currentParticipant.isRemoved
                                ? `Restore ${currentParticipant.displayName || 'this participant'} to this list?`
                                : `Are you sure you want to remove ${currentParticipant.displayName ||
                                'this participant'} from this list?  
                                                    \nThis participant will be permanently removed and will need to manually added in order to be included again.`
                          }
                          close={() => {
                            this.setState({ currentParticipant: {} }, () =>
                              this.toggleModal('removeRestoreConfirmationModal')
                            );
                          }}
                          confirm={currentParticipant.isRemoved ? this.restoreParticipant : this.removeParticipant}
                          loading={listUpdate.loading}
                          success={listUpdate.success}
                        />

                        <ExternalParticipantModal
                          show={showModals.externalParticipantModal}
                          close={() => {
                            this.toggleModal('externalParticipantModal');
                            this.setState({ currentParticipant: {} });
                          }}
                          isBatched={isBatched}
                          isIsraeli={isIsraeli}
                          isOrgList={campaignList.isOrgList}
                          locationId={campaignList.locationId}
                          participant={currentParticipant}
                          submit={currentParticipant.externalListMemberId ? this.updateParticipant : this.addParticipant}
                          loading={listUpdate.loading}
                          success={listUpdate.success}
                          locationGroups={locationGroups}
                          orgEmploymentTypes={orgEmploymentTypes}
                          previousEmploymentTypes={previousEmploymentTypes}
                          titles={isIsraeli ? israelPersonTitles : usPersonTitles}
                        />

                        <SelectExternalParticipantModal
                          show={showModals.selectExternalParticipantModal}
                          close={() => this.toggleModal('selectExternalParticipantModal')}
                          showCreate={() => this.toggleModals(['selectExternalParticipantModal', 'externalParticipantModal'])}

                          listRecipients={listRecipients}
                          clearRecipientSuggestions={this.props.actions.clearRecipientSuggestions}
                          getRecipientSuggestions={(recipientName) =>
                            this.props.actions.getRecipientSuggestions(recipientName, {
                              applicantType: RecipientTypes.Individual,
                              departments: [isIsraeli ? Departments.IL : Departments.US],
                              ...(!campaignList.isOrgList
                                ? { locationId: campaignList.locationId }
                                : {})
                            }, listRecipients.data)}
                          recipientSuggestions={this.props.recipientSuggestions}

                          submit={this.addParticipant}
                          loading={listUpdate.loading}
                          success={listUpdate.success}
                        />

                      <ConfirmationModal
                        show={showModals.submitListConfirmationModal}
                        message={`Are you sure you would like to submit ${campaignList.name} Campaign List?`
                          +
                          (!campaignList.hasUnsubmittedChanges
                            ? "\nYou have not made any updates to this list."
                            : "")
                          +
                          (isBatched
                            ? "\n\nOnce submitted, your list will await review and verification by an SFTF staff member and will not be available for viewing or updating until the verification process is complete."
                            : "")}
                        close={() => this.toggleModal('submitListConfirmationModal')}
                        confirm={this.submitList}
                        loading={listSubmission.loading}
                        success={listSubmission.success}
                        errorMessage={listSubmission.message}
                      />
                      </div>
                    )}
                </div>
              )
            )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    listDetails: state.externalCampaignList.listDetails,
    listRecipients: state.externalCampaignList.listRecipients,
    listExport: state.externalCampaignList.listExport,
    listUpdate: state.externalCampaignList.listUpdate,
    listSelection: state.externalCampaignList.listSelection,
    listSubmission: state.externalCampaignList.listSubmission,
    participantsList: state.externalCampaignListParticipantsList,
    recipientSuggestions: state.suggestions.recipientSuggestions,
    settings: {
      ...state.settings.systemSettings.data.recipientSettings,
      ...state.settings.systemSettings.data.otherSettings,
      ...state.settings.systemSettings.data.campaignSettings
    }
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({
      ...externalCampaignListsActions,
      ...suggestionActions,
    }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ExternalCampaignListPage);



// WEBPACK FOOTER //
// ./src/components/campaignComponents/externalLists/ExternalCampaignListPage.jsx